
import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';

const styles = {
    
}
const useStyles = makeStyles(theme => ({
    
    '@keyframes rotateCircleEffect': {
        '0%': {
            transform: 'rotate(-45deg)'
        },
        '5%': {
            transform: 'rotate(-45deg)'
        },
        '12%': {
            transform: 'rotate(-405deg)'
        },
        '100%': {
            transform: 'rotate(-405deg)'
        }
    },
    
    '@keyframes iconLineTipEffect': {
        '0%': {
            width: '0',
            left: '1px',
            top: '19px'
        },
        '54%': {
            width: '0',
            left: '1px',
            top: '19px'
        },
        '70%': {
            width: '50px',
            left: '-8px',
            top: '37px'
        },
        '84%': {
            width: '17px',
            left: '21px',
            top: '48px'
        },
        '100%': {
            width: '25px',
            left: '14px',
            top: '45px'
        }
    },
    
    '@keyframes iconLineLongEffect':  {
        '0%': {
            width: '0',
            right: '46px',
            top: '54px'
        },
        '65%': {
            width: '0',
            right: '46px',
            top: '54px',
        },
        '84%': {
            width: '55px',
            right: '0px',
            top: '35px'
        },
        '100%': {
            width: '47px',
            right: '8px',
            top: '38px'
        }
    },
    

    successCheckmark: props => ({
        width: "80px",
        height: "115px",

        '& .check-icon': {
            width: "80px",
            height: "80px",
            position: "relative",
            borderRadius: "50%",
            boxSizing: "content-box",
            border: `4px solid ${props.color && eval(props.color) || '#4CAF50'}`,


            '&::before': {
                top: "3px",
                left: "-2px",
                width: "30px",
                transformOrigin: "100% 50%;",
                borderRadius: "100px 0 0 100px",
                content: '""',
                height: "100px",
                position: "absolute",
                background: props.backgroundColor && eval(props.backgroundColor) || '#FFFFFF',
                transform: "rotate(-45deg)"
            },
    
            '&::after': {
                top: "0",
                left: "30px",
                width: "60px",
                transformOrigin: "0 50%",
                borderRadius: "0 100px 100px 0",
                animation: `$rotateCircleEffect 4.25s ease-in`,
                content: '""',
                height: "100px",
                position: "absolute",
                background: props.backgroundColor && eval(props.backgroundColor) || '#FFFFFF',
                transform: "rotate(-45deg)"
            },

            '& .icon-line': {
                height: '5px',
                backgroundColor: props.color && eval(props.color) || '#4CAF50',
                display: 'block',
                borderRadius: '2px',
                position: 'absolute',
                zIndex: '10',
                
                '&.line-tip': {
                    top: '46px',
                    left: '14px',
                    width: '25px',
                    transform: 'rotate(45deg)',
                    animation: `$iconLineTipEffect 0.75s`
                },
                
                '&.line-long': {
                    top: '38px',
                    right: '8px',
                    width: '47px',
                    transform: 'rotate(-45deg)',
                    animation: `$iconLineLongEffect 0.75s`
                }
            },

            '& .icon-circle': {
                top: '-4px',
                left: '-4px',
                zIndex: '10',
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                position: 'absolute',
                boxSizing: 'content-box',
                border: '4px solid rgba(76, 175, 80, .5)'
            },
            
            '& .icon-fix': {
                top: '8px',
                width: '5px',
                left: '26px',
                zIndex: '1',
                height: '85px',
                position: 'absolute',
                transform: 'rotate(-45deg)',
                backgroundColor: props.backgroundColor && eval(props.backgroundColor)  || '#FFFFFF'
            }
        },
    }),
}));

const AnimatedCheckIcon = (props) => {
    const classes = useStyles(props);
    return (<div className={classes.successCheckmark}>
        <div className="check-icon">
            <span className="icon-line line-tip"></span>
            <span className="icon-line line-long"></span>
            <div className="icon-circle"></div>
            <div className="icon-fix"></div>
        </div>
    </div>)
}

export default withStyles(useStyles)(AnimatedCheckIcon);


// WEBPACK FOOTER //
// ./src/client/components/AnimationCheck.js